import React from 'react'

import type { ContainerBlock as BlockProps } from '@/payload-types'
import { RenderBlocks } from '@/blocks/RenderBlocks'
import { cn } from '@/utilities/cn'

export const ContainerBlock: React.FC<BlockProps> = async ({ layout, center, narrow, padding }) => {
  return (
    <div
      className={cn('container', center && 'mx-auto', narrow && 'max-w-4xl')}
      style={{ padding: padding ?? undefined }}
    >
      <RenderBlocks blocks={layout ?? []} />
    </div>
  )
}
